import React from 'react';
import { connect } from 'react-redux';
import { deleteNotif } from './redux/reduxApi';
import { closeModal } from '../../../app/modals/redux/modalActions';
import useScreenWidth from '../../../app/common/helpers/useScreenWidth';
import Modal from '../../../ui/Modal';
import Button from '../../../ui/Button';

const actions = {
  closeModal,
  deleteNotif,
};

function ModalDeleteNotif({ deleteNotif, data, closeModal }) {
  const auth = data?.auth;
  const item = data?.item;
  const history = data?.history;
  const screenWidth = useScreenWidth();

  function handleDelete() {
    deleteNotif({ auth, history, data: item, id: item.id });
    closeModal();
  }

  return (
    <Modal
      variant='danger'
      closeModal={closeModal}
      width={screenWidth > 500 ? 500 : screenWidth}
    >
      <p className='px-4 my-5 mx-1'>
        Apakah Anda ingin menghapus notifikasi{' '}
        <span className='has-text-danger has-text-weight-semibold'>
          {item.title}
        </span>
        ?
      </p>
      <div className='flex flex-column justify-start mx-5 my-3'>
        <p className='is-size-6 is-italic mb-2'>
          <span className='tag is-info is-light is-rounded'>Note:</span>
        </p>
        <ol className='mx-4' style={{ fontSize: 13 }}>
          <li>
            User bisa mengirim ulang notifikasi, tetapi notifikasi yang telah
            terkirim tetap diterima oleh siswa.
          </li>
          <li>
            Mengirim berulang notifikasi yang sama dapat membuat siswa terganggu,
            pastikan hanya mengirimkan notifikasi 1x.
          </li>
        </ol>
      </div>
      <div className='flex justify-end align-center px-4 pt-2'>
        <div className='buttons'>
          <Button cvariant='cdelete' onClick={handleDelete} />
          <Button cvariant='cback' onClick={closeModal} />
        </div>
      </div>
    </Modal>
  );
}

export default connect(null, actions)(ModalDeleteNotif);
